import React from "react";
import { motion } from "framer-motion";

export default function GlassCard({
  children,
  className = "",
  glow = false,
  hoverable = true,
  delay = 0,
  ...rest
}) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ type: "spring", stiffness: 320, damping: 28, delay }}
      whileHover={hoverable ? { y: -2 } : undefined}
      className={
        "relative rounded-[16px] glass " +
        (glow ? "glow-primary " : "") +
        (hoverable ? "glass-hover transition-shadow " : "") +
        className
      }
      {...rest}
    >
      {children}
    </motion.div>
  );
}
